module.exports = __webpack_public_path__ + "img/add-issue.a954e519.svg";